import { isNilOrEmpty } from '../../../helpers/utils';

// eslint-disable-next-line
export function getResultsLength(result) {
  if (isNilOrEmpty(result) || isNilOrEmpty(result.data)) {
    return 0;
  }
  return result.data.length;
}
